module.exports = __webpack_public_path__ + "static/media/swiper.cd72c110.less";